const DEFAULT_TOLERANCE = 0.005;

/**
 * Compare two money-like values with a small tolerance (mixed string/number from API).
 */
export function amountsCloseEnough(a, b, tolerance = DEFAULT_TOLERANCE) {
  const x = Number(a);
  const y = Number(b);
  if (!Number.isFinite(x) || !Number.isFinite(y)) return false;
  return Math.abs(x - y) <= tolerance;
}

function scheduleRowAmount(schedule) {
  if (schedule == null) return NaN;
  return schedule.paymentAmount ?? schedule.amount;
}

/**
 * Count installments matching the plan standard amount. Falls back to numPayments-based
 * estimate when matching yields zero but the schedule is non-empty (type/rounding drift).
 */
export function countStandardInstallmentsInSchedule(
  paymentSchedule,
  standardPaymentAmount,
  numPayments,
  isFinalAmountDifferent,
) {
  if (!Array.isArray(paymentSchedule) || paymentSchedule.length === 0) {
    return null;
  }

  let count = paymentSchedule.filter((row) =>
    amountsCloseEnough(
      scheduleRowAmount(row),
      standardPaymentAmount,
    ),
  ).length;

  const n = Number(numPayments);
  if (count === 0 && Number.isFinite(n) && n > 0) {
    const fallback = isFinalAmountDifferent ? Math.max(0, n - 1) : n;
    count = Math.min(fallback, paymentSchedule.length);
  }

  if (isFinalAmountDifferent && count === paymentSchedule.length) {
    count = Math.max(0, count - 1);
  }

  return count;
}
